import { tldExists } from 'tldjs';
import isEmail from 'validator/lib/isEmail';

export const isValidEmail = (string) =>
  string &&
  typeof string === 'string' &&
  !string.includes('/') &&
  isEmail(string) &&
  tldExists(string);
